import ComponentManager from "../../componentFramework";
import Log from "../../scripts/Log";

/**
 */
@ComponentManager.register()
export default class Messages {
	public static componentStyleClass = "messages";

	/**
	 * This method creates the HTML to display a messages window.
	 * It will result in an instance of this Messages class to be constructed.
	 */
	public static createDesktopMessages(messages: Array<string>, maximumSeverity: "fatal"|"error"|"warn"|"info") {
		if (messages.length < 1) {
			return;
		}

		// Build HTML to insert
		// Keep the HTML in line with Messages.xhtml // TODO (Michael): Share HTML instead of duplicating. To do that perhaps have our JSF templating export JSON elements instead which we watch for and generate the HTML in this TS file instead. We insert JSON for the in-website toolbar.
		let html = `
			<div class="messages messages--maximumSeverity_${maximumSeverity} messages--count_${messages.length} messages--desktopFixed">
				<a href="#" class="messages__dismiss">Close</a>
				<div class="messages__content">
				<p>Please address the following:</p>
				<ul>
		`;
		for (let i=0; i < messages.length; i++ ) {
			html += `	<li>${messages[i]}</li>`;
		}
		html += `	</ul>
				</div>
			</div>
		`;

		// Insert the HTML
		const insertPoint = document.getElementById("desktopMessages");
		if (insertPoint === null) {
			Log.error(`Messages could not insert HTML to create a desktop messages because element with "desktopMessages" ID could not be found`);
		} else {
			insertPoint.insertAdjacentHTML("afterbegin", html);
		}
	}


	constructor(private readonly rootElement: HTMLElement) {
		const dismissElem = rootElement.querySelector<HTMLElement>(".messages__dismiss");
		if (dismissElem !== null) {
			dismissElem.addEventListener("click", this.onDismissClick);
		}

		requestAnimationFrame(() => { rootElement.classList.add("isInited"); });
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		const dismissElem = this.rootElement.querySelector<HTMLElement>(".messages__dismiss");
		if (dismissElem !== null) {
			dismissElem.removeEventListener("click", this.onDismissClick);
		}
	}

	private readonly onDismissClick = (ev: MouseEvent) => {
		ev.preventDefault();
		const removeAtEndOfAnimation = ({}: TransitionEvent) => {
			this.rootElement.removeEventListener("transitionend", removeAtEndOfAnimation);
			this.rootElement.remove();
		};
		this.rootElement.addEventListener("transitionend", removeAtEndOfAnimation);
		this.rootElement.classList.add("isClosing");
	}
}
